import React from 'react';
import { Modal } from '../games/gameBits';

export default function ConfirmDialog({ message, confirmLabel, onConfirm, onClose, busy }) {
  return (
    <Modal label={message} onClose={onClose} className="squad-confirm">
      <p className="squad-confirm-text">{message}</p>
      <div className="games-dialog-actions">
        <button type="button" className="games-btn is-ghost" onClick={onClose} disabled={busy}>Cancel</button>
        <button type="button" className="games-btn is-danger" onClick={onConfirm} disabled={busy}>{confirmLabel}</button>
      </div>
    </Modal>
  );
}
